import { useEffect, useState } from "react"
import { Progress } from "@/shared/ui/progress.tsx"

export default function ProgressLoader() {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    // Total duration: 1.5 minutes (90 seconds)
    // We want to reach 99% in that time
    const duration = 90 * 1000 // 90 seconds in milliseconds
    const interval = 100 // Update every 100ms for smooth animation
    const steps = duration / interval
    const incrementPerStep = 99 / steps

    let currentProgress = 0
    const timer = setInterval(() => {
      currentProgress += incrementPerStep

      // Ensure we don't exceed 99%
      if (currentProgress >= 99) {
        currentProgress = 99
        clearInterval(timer)
      }

      setProgress(currentProgress)
    }, interval)

    return () => clearInterval(timer)
  }, [])

  return (
    <div className="w-full max-w-md mx-auto space-y-4">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-lg font-medium">Loading</h2>
        <span className="text-sm font-medium">{Math.round(progress)}%</span>
      </div>
      <Progress value={progress} className="h-2" />
      <p className="text-sm text-muted-foreground text-center">
        {progress < 99 ? "Processing your request..." : "Almost ready..."}
      </p>
    </div>
  )
}
